import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environment';
import { NotificationBar } from 'src/services/notification.service';
import { emsCompetition } from 'src/models/emsModels';

@Component({
  selector: 'app-team-create',
  templateUrl: './team-create.component.html',
  styleUrl: './team-create.component.scss'
})
export class TeamCreateComponent {

  notificationBar: NotificationBar;
  teamGroup = new FormGroup({
    nameControl: new FormControl('', [Validators.required]),
    tricodeControl: new FormControl('', [Validators.required]),
    competitionControl: new FormControl('', [Validators.required]),
    logoControl: new FormControl('', []),
  });
  isProcessing = false;
  workspaceID = "";
  competitions = Array<emsCompetition>();
  placeholderImage = environment.placeholderImage;
  competitionsDBRef: any;

  constructor(private title: Title, private router: Router, private route: ActivatedRoute, private location: Location, private snackBar: MatSnackBar, private fireStorage: AngularFireStorage, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
  }
  
  ngOnInit() {  
    this.title.setTitle("Create Team - EsportsMS");
    this.route.paramMap.subscribe(params => {
      this.workspaceID  = this.location.path().split("/")[1];
    });
    this.loadCompetitions();
  }

  ngOnDestroy() {
    if (this.competitionsDBRef) {
      this.competitionsDBRef.off('value');
    };
  }

  loadCompetitions() {
    this.competitionsDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/competitions').orderByChild('workspace').equalTo(this.workspaceID);
    this.competitionsDBRef.on('value', x => {
      this.competitions = new Array<emsCompetition>();
      x.forEach( x => {
        var competition = x.toJSON() as emsCompetition;
        competition.uid = x.key;
        this.competitions.push(competition);
      });
      this.competitions.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getSelectedCompetition(uid: string) {
    return this.competitions.find(competition => competition.uid == uid);
  }
  
  async createTeam() {
    var teamDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/teams/');
    var newTeamRef = teamDBRef.push();
    newTeamRef.set({
      'workspace': this.workspaceID,
      'name': this.teamGroup.controls.nameControl.value,
      'tricode': this.teamGroup.controls.tricodeControl.value,
      'competition': this.teamGroup.controls.competitionControl.value,
      'logo': this.teamGroup.controls.logoControl.value,
    });
    this.router.navigate([ this.workspaceID + '/t/' + newTeamRef.key]);
    this.notificationBar.show("Team created!")
  }
}